// Export all themes from a single file
import { baseCardTheme } from "./TeamBaseCardTheme"
import { cardDesign5Theme } from "./TeamCardDesign5Theme"
import { cardDesign5PreviewTheme } from "./TeamCardDesign5PreviewTheme"
import { CardDesign5FloatingButtonTheme } from "./TeamCardDesign5FloatingButtonTheme"

// Export the themes
export { baseCardTheme, cardDesign5Theme, cardDesign5PreviewTheme, CardDesign5FloatingButtonTheme }

export const CARD_THEMES = {
    design5: cardDesign5Theme,
    design5Preview: cardDesign5PreviewTheme,
    design5FloatingButton: CardDesign5FloatingButtonTheme
}